import React, { createRef, useState } from "react";
import { ProductActiveComponentModel } from "@admin/domain/products/models/edit/ProductSpecificationsModel";
import { getActiveComponentByAccountingId } from "@admin/domain/products/api";
import { useLanguageContext } from "@admin/components/LanguagesContext";
import convertToLanguageMap from "@admin/domain/languages/helpers";
import Sortable from "@admin/components/Sortable";
import Input from "@admin/components/Input";

export default function ActiveComponents(props: { activeComponents: ProductActiveComponentModel[] }) {
    const currentLanguage = useLanguageContext().currentLanguage;
    const [productActiveComponents, setProductActiveComponents] = useState(props.activeComponents);
    const inputRef = createRef<HTMLInputElement>();

    async function addActiveComponent() {
        const accountingId = inputRef.current?.value;
        if (!accountingId) {
            return;
        }

        await getActiveComponentByAccountingId(accountingId).then((activeComponent) => {
            if (!activeComponent) {
                return;
            }

            activeComponent.textsMap = convertToLanguageMap(activeComponent.texts);
            setProductActiveComponents((prevState) => [
                ...prevState,
                {
                    id: 0,
                    active_component: activeComponent,
                    url: null,
                },
            ]);
        });
    }

    return (
        <div className="rounded border p-10 mb-5">
            <h4 className="mb-5">Активные компоненты</h4>

            <div className="input-group mb-5 w-50">
                <input type="text" className="form-control" placeholder="UUID активного компонента" ref={inputRef} />
                <button className="btn btn-primary" type="button" onClick={addActiveComponent}>
                    Добавить
                </button>
            </div>

            <Sortable list={productActiveComponents} setList={setProductActiveComponents}>
                {productActiveComponents.map(({ active_component, url }, index) => (
                    <div key={`${active_component.id}-${index}`} className="card border mb-4 position-relative">
                        <div className="card-body">
                            <input
                                type="hidden"
                                name={`specifications[active_components][${index}][id]`}
                                value={active_component.id}
                            />

                            <div>
                                <span className="fw-bolder">UUID:</span>
                                {` `}
                                {active_component.accounting_id}
                            </div>
                            <div>
                                <span className="fw-bolder">Название:</span>
                                {` `}
                                {active_component.textsMap?.get(currentLanguage)?.title}
                            </div>
                            <div>
                                <span className="fw-bolder">Ссылка:</span>
                                <Input
                                    defaultValue={url || ``}
                                    name={`specifications[active_components][${index}][url]`}
                                />
                            </div>
                        </div>
                        <i
                            className="bi bi-x-circle position-absolute text-danger end-0 mt-5 me-5 cursor-pointer"
                            onClick={() =>
                                setProductActiveComponents((prevState) =>
                                    prevState.filter((prevValue) => prevValue.id !== active_component.id),
                                )
                            }
                        />
                    </div>
                ))}
            </Sortable>
        </div>
    );
}
